// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "knowledge_entry".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { knowledgeEntryTypeValues, knowledgeSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "knowledge_entry" table (1:1 with a DB row, on the wire). */
export const knowledgeEntryAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string().nullable(),
    userId: z.string().nullable(),
    type: z.enum(knowledgeEntryTypeValues),
    title: z.string(),
    content: z.string(),
    embedding: z.array(z.number()).nullable(),
    metadata: z.unknown().nullable(),
    source: z.enum(knowledgeSourceValues).nullable(),
    confidence: z.number().nullable(),
    expiresAt: z.string().datetime().nullable(),
    scopeSkillIds: z.array(z.string()).nullable(),
    enabled: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=knowledgeEntry.js.map